import React from "react";
import {
  Box,
  HStack,
  CheckIcon,
  Text,
  ZStack,
  useMediaQuery,
} from "native-base";
import { COLORS } from "../../utils/colors";
import { MOBILE_VIEW_WIDTH } from "../../utils/screens";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../utils/fonts";

const ProgressStepsBar = ({
  steps = 4,
  currentStep = 1,
  stepNames = ["", "", "", ""],
}) => {
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });

  const getSize = (step, currentStep) => {
    if (step === currentStep) {
      return "16px";
    } else if (step + 1 <= currentStep) {
      return "18px";
    } else {
      return "12px";
    }
  };

  const getBg = (step, currentStep) => {
    if (step === currentStep) {
      return COLORS.THEME_COLOR;
    } else if (step + 1 <= currentStep) {
      return COLORS.THEME_COLOR;
    } else {
      return COLORS.ATTACHMENT_FILES_BORDER_COLOR;
    }
  };

  const getPadding = (step) => {
    if (step === 0) {
      if (MobileWindow) return "85px";
      return "75px";
    } else if (step === 1) {
      if (MobileWindow) return "82px";
      return "75px";
    } else if (step === 2) {
      if (MobileWindow) return "70px";
      return "58px";
    } else {
      if (MobileWindow) return "0px";
      return "0px";
    }
  };

  const getTextColor = (step) => {
    if (step === currentStep) {
      return COLORS.BLACK_COLOR;
    } else if (step + 1 <= currentStep) {
      return COLORS.THEME_COLOR;
    } else {
      return COLORS.PROGRESSBAR_TEXT_COLOR;
    }
  };

  const getFontWeight = (step) => {
    if (step === currentStep) {
      return COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT;
    } else {
      return COMMONFONTWEIGHT.SMALL_FONT_WEIGHT;
    }
  };

  const getLineColor = (step, currentStep) => {
    if (step + 1 <= currentStep) {
      return COLORS.THEME_COLOR;
    } else if (step === currentStep) {
      return COLORS.BLACK_COLOR;
    } else {
      return COLORS.ATTACHMENT_FILES_BORDER_COLOR;
    }
  };

  return (
    <Box mb={6} ml={2}>
      <HStack mt={2}>
        {[...Array(steps).keys()].map((step) => (
          <React.Fragment key={step + 1}>
            {
              <>
                <ZStack mr={2} justifyContent="center" alignItems="center">
                  <Box
                    size="sm"
                    bg={getBg(step, currentStep)}
                    width={getSize(step, currentStep)}
                    height={getSize(step, currentStep)}
                    borderRadius="full"
                    justifyContent="center"
                    alignItems="center"
                    mt={step + 1 > currentStep && step !== currentStep && "2px"}
                    ml={step + 1 > currentStep && step !== currentStep && "5px"}
                  >
                    <Text
                      color={getTextColor(step)}
                      paddingLeft={getPadding(step)}
                      paddingRight={
                        (MobileWindow &&
                          (stepNames[step] === "Documents"
                            ? "60px"
                            : "20px")) ||
                        (step === 3 && "60px")
                      }
                      width={"max-content"}
                      mt={12}
                      fontWeight={getFontWeight(step)}
                      fontSize={MobileWindow && COMMONFONTSIZE.SMALL_FONT_SIZE}
                    >
                      {stepNames[step]}
                    </Text>
                  </Box>
                  {step + 1 <= currentStep ? (
                    <Box>
                      <CheckIcon size="2" color="white" borderWidth="2" />
                    </Box>
                  ) : (
                    <Box></Box>
                  )}
                </ZStack>
                {step < steps - 1 && (
                  <Box
                    height="1px"
                    width={
                      MobileWindow
                        ? stepNames[step] === "Attendees"
                          ? "35%"
                          : "28%"
                        : "32%"
                    }
                    marginLeft="0"
                    bg={getLineColor(step, currentStep)}
                    borderRadius="9999px"
                  />
                )}
              </>
            }
          </React.Fragment>
        ))}
      </HStack>
    </Box>
  );
};

export default ProgressStepsBar;
